import { useState } from "react";

export function useMapState() {
  const [hoveredStopIndex, setHoveredStopIndex] = useState<number | null>(null);
  const [isDraggingMarker, setIsDraggingMarker] = useState(false);
  const [routeValid, setRouteValid] = useState(true);
  const [routePlotted, setRoutePlotted] = useState(false);

  return {
    hoveredStopIndex,
    setHoveredStopIndex,
    isDraggingMarker,
    setIsDraggingMarker,
    routeValid,
    setRouteValid,
    routePlotted,
    setRoutePlotted,
  };
}